export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
export const SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE = "SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE";
export const SAVING_NATIONAL_HEALTH_INSURANCE_SECTION = "SAVING_NATIONAL_HEALTH_INSURANCE_SECTION";
export const SAVING_CITIZEN_LIFE_SAFETY_SECTION = "SAVING_CITIZEN_LIFE_SAFETY_SECTION";
